export const RIDING_STYLE_OPTIONS = [
  { label: 'ゆるポタ・カフェ巡り', description: '美味しいものや景色を重視。街乗り中心。' },
  { label: 'ポタリング・街乗り', description: '短距離の散策や日常使い。' },
  { label: '輪行', description: '電車で移動して現地だけ走るスタイル。' },
  { label: 'ロングライド・ツーリング', description: '100km超の長距離走行。旅が目的。' },
  { label: 'ヒルクライム', description: '峠や山を登るのが好き。坂バカ。' },
  { label: 'トレーニング・ワークアウト', description: '速さや出力を重視。高強度で走る。' },
  { label: 'グラベル・アドベンチャー', description: '未舗装路、砂利道、キャンプツーリング。' },
  { label: 'ブルベ（超長距離）', description: '200km〜1000km超の認定走行。夜通し走る。' },
  { label: 'レース・イベント参加', description: 'ロードレースやクリテリウム、市民レースに出る。' },
] as const;

export type RidingStyleOption = (typeof RIDING_STYLE_OPTIONS)[number]['label'];

export const MONTHLY_DISTANCE_OPTIONS = [
  { label: '〜100km', description: 'たまに楽しむ。月1〜2回の週末ライダー。' },
  { label: '100km〜300km', description: '定期的に走る。週1回の週末ライダー、自転車通勤。' },
  { label: '300km〜500km', description: '走り込んでいる。本格的な趣味として楽しむ層。' },
  { label: '500km〜1,000km', description: 'ガチ勢。トレーニングや長距離を日常的に行う層。' },
  { label: '1,000km以上', description: '猛者。実業団レベル、または自転車が生活の一部。' },
] as const;

export type MonthlyDistanceOption = (typeof MONTHLY_DISTANCE_OPTIONS)[number]['label'];
